import { ContextActionData, StoreState } from 'types/reducers';
import { StoreActions } from './actions';

export const defaultState: StoreState = {
    supplierItems: [],
    addressTypes: [],
    entityTypes: [],
    attachmentTypes: [],
    paymentScope: [],
    paymentType: [],
};

const storeReducer: (state: StoreState, actions: ContextActionData<any>) => StoreState = (
    state = defaultState,
    action: ContextActionData<any>,
) => {
    switch (action.type) {
        case StoreActions.SET_SUPPLIERS:
            return {
                ...state,
                supplierItems: action.payload,
            };
        case StoreActions.SET_ADDRESS_TYPES:
            return {
                ...state,
                addressTypes: action.payload,
            };
        case StoreActions.SET_ATTACHMENT_TYPES:
            return {
                ...state,
                attachmentTypes: action.payload,
            };
        case StoreActions.SET_ENTITY_TYPES:
            return {
                ...state,
                entityTypes: action.payload,
            };
        case StoreActions.SET_PAYMENT_SCOPE:
            return {
                ...state,
                paymentScope: action.payload,
            };
        case StoreActions.SET_PAYMENT_TYPES:
            return {
                ...state,
                paymentType: action.payload,
            };
        default:
            return state;
    }
};

export default storeReducer;
